import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingDowngradePendingDataProvider from '@/components/Billing/BillingDowngradePendingDataProvider.vue';
// @ts-ignore
import BillingPlanCardDataProvider from '@/components/Billing/BillingPlanCardDataProvider.vue';
// @ts-ignore
import FreeBetaPlanIndicator from '@/components/Billing/FreeBetaPlanIndicator.vue';
import BillingService from '@/components/Billing/billing-service';
import { VIRTUALLY_UNLIMITED_IDENTIFIER } from '@/components/Billing/billing-service.const';
import { Plan, ProductType } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingFeaturesSection',
  props: {
    plans: null,
    activePlan: null,
    selectedPlan: null,
    productType: null,
    isCurrentTeamTasksVirtuallyUnlimited: { type: Boolean },
    currentAccountCustomerFeatureQuantity: null
  },
  emits: ["select-plan", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select-plan', planId: string): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plans: Plan[];
	activePlan: string;
	selectedPlan: string;
	productType: ProductType;
	isCurrentTeamTasksVirtuallyUnlimited?: boolean;
	currentAccountCustomerFeatureQuantity?: number;
}




const { useSubscriptionByProductType } = useBilling();
const showPendingDowngrade = computed(() => BillingService.isPendingDowngrade(useSubscriptionByProductType.value(props.productType)));
const currentPlan = computed(() => props.plans.find((plan) => plan.refId === props.activePlan));
const shouldShowFreeBetaPlan = computed(() => {
	if (!currentPlan.value) {
		throw new Error('Active plan not found');
	}
	return BillingService.IsPlanFreeBeta(currentPlan.value);
});

const virtuallyUnlimitedPlans = computed(() => props.plans.filter((plan) => BillingService.isVirtuallyUnlimitedRefId(plan.refId)));
const plansToShow = computed(() => {
	const plansToShow: Plan[] = [];
	props.plans.forEach((plan) => {
		if (BillingService.isVirtuallyUnlimitedRefId(plan.refId)) {
			return;
		}
		if (BillingService.IsPlanFreeBeta(plan)) {
			// Do not show free beta plan
		} else {
			plansToShow.push(plan);
		}
	});
	return plansToShow.filter((plan) => plan);
});

const getVirtualUnlimitedSiblingPlan = (plan: Plan) => {
	if (BillingService.isPaidPlan(plan)) {
		return virtuallyUnlimitedPlans.value.find((unlimitedPlan) => unlimitedPlan.refId === `${plan.refId}-${VIRTUALLY_UNLIMITED_IDENTIFIER}`);
	} else {
		return null;
	}
};

return { __sfc: true,emit, props, useSubscriptionByProductType, showPendingDowngrade, currentPlan, shouldShowFreeBetaPlan, virtuallyUnlimitedPlans, plansToShow, getVirtualUnlimitedSiblingPlan, BillingDowngradePendingDataProvider, BillingPlanCardDataProvider, FreeBetaPlanIndicator }
}

})